import { render, staticRenderFns } from "./ThreadList.vue?vue&type=template&id=5357f3a4"
import script from "./ThreadList.vue?vue&type=script&lang=ts"
export * from "./ThreadList.vue?vue&type=script&lang=ts"
import style0 from "./ThreadList.vue?vue&type=style&index=0&id=5357f3a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports